import { Link, LinkProps } from '@mui/material';
import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

interface RouterLinkProps extends Omit<LinkProps, 'ref'>, Omit<NavLinkProps, keyof LinkProps> {
    children?: React.ReactNode;
}

export class RouterLink extends React.Component<RouterLinkProps> {
    public render(): React.ReactNode {
        const { children, ...remaining } = this.props;

        return (
            <Link {...remaining} component={NavLink} underline='hover'>
                {children}
            </Link>
        );
    }
}
